import React from "react";
import { Navigate } from "react-router-dom";

function AuthGuard({ children }) {
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

export default AuthGuard;